var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import Spinner from './components/Spinner';
import useMountedRef from './hooks/useMountedRef';
import './Photo.css';
export default function Photo(_a) {
    var src = _a.src, loaded = _a.loaded, broken = _a.broken, className = _a.className, onPhotoLoad = _a.onPhotoLoad, loadingElement = _a.loadingElement, brokenElement = _a.brokenElement, restProps = __rest(_a, ["src", "loaded", "broken", "className", "onPhotoLoad", "loadingElement", "brokenElement"]);
    var mountedRef = useMountedRef();
    function handleImageLoaded(e) {
        var _a = e.target, naturalWidth = _a.naturalWidth, naturalHeight = _a.naturalHeight;
        if (mountedRef.current) {
            onPhotoLoad({
                loaded: true,
                naturalWidth: naturalWidth,
                naturalHeight: naturalHeight,
            });
        }
    }
    function handleImageBroken() {
        if (mountedRef.current) {
            onPhotoLoad({
                broken: true,
            });
        }
    }
    if (src && !broken) {
        return (_jsxs(_Fragment, { children: [_jsx("img", __assign({ className: "PhotoView__Photo".concat(className ? " ".concat(className) : ''), src: src, onLoad: handleImageLoaded, onError: handleImageBroken, alt: "" }, restProps)), !loaded && (_jsx("span", __assign({ className: "PhotoView__icon" }, { children: loadingElement })) || _jsx(Spinner, { className: "PhotoView__icon" }))] }));
    }
    if (brokenElement) {
        return _jsx("span", __assign({ className: "PhotoView__icon" }, { children: typeof brokenElement === 'function' ? brokenElement({ src: src }) : brokenElement }));
    }
    return null;
}
